/* src/app/module/service-provider/add-sp-new-component/service-offered/service-offered-new.component.scss */
.heading {
  margin-bottom: 43px;
  font-size: 20px;
  font-weight: 600;
}
.checkbox-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.custom-checkbox {
  position: relative;
  display: inline-block;
  padding-left: 30px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  line-height: 1.5;
}
.custom-checkbox input[type=checkbox] {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
.custom-checkbox .checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #d0d5dd;
  border-radius: 16px;
  background-color: #ffffff;
  transition: background-color 0.3s ease;
}
.custom-checkbox input[type=checkbox]:checked + .checkbox-box {
  background-color: #FFC680;
  border-color: #FFC680;
}
.custom-checkbox .checkmark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.custom-checkbox input[type=checkbox]:checked + .checkbox-box .checkmark {
  opacity: 0;
}
.custom-checkbox input[type=checkbox]:disabled + .checkbox-box {
  background-color: #f0f0f0;
  border-color: #d0d5dd;
}
.custom-checkbox .checkbox-label {
  padding-left: 8px;
}
button.btn.btn-primary {
  padding: 10px 15px;
  border-radius: 5px;
  margin-top: 43px;
  font-size: 16px;
  font-weight: 600;
}
.dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.services-container {
  margin-top: 20px;
}
.submit-button {
  background-color: #ffa500;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.submit-button:hover {
  background-color: #ff8c00;
}
.search-container {
  position: relative;
}
.search-icon {
  position: absolute;
  top: 52%;
  left: 14px;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 16px;
  pointer-events: none;
  color: #667085;
}
.search-box {
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding-left: 40px;
}
form {
  width: 750px;
}
.serviceListscatagory {
  margin-top: 16px;
}
::ng-deep .p-inputtext,
::ng-deep .p-dropdown {
  border: 1px solid #D0D5DD !important;
  border-radius: 8px !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  font-size: 16px;
  font-weight: 400;
  color: #344054 !important;
  display: flex;
  align-items: center;
  margin-top: 4px;
}
::ng-deep .p-dropdown span {
  margin: 0px;
}
::ng-deep .p-dropdown {
  padding: 10px 14px !important;
  margin-left: 15px;
  width: 250px;
}
::ng-deep .p-dropdown .p-dropdown-panel {
  width: 250px;
}
::ng-deep .p-inputtext::placeholder,
::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  color: #667085 !important;
  font-size: 16px;
  font-weight: 400;
}
::ng-deep input:-webkit-autofill {
  background-color: white !important;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: black !important;
}
::ng-deep .p-inputtext:hover,
::ng-deep .p-dropdown:focus,
::ng-deep .p-dropdown:hover,
::ng-deep .p-inputtext:focus {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
::ng-deep .p-dropdown.p-focus,
::ng-deep .p-dropdown.p-highlight,
::ng-deep .p-dropdown:focus-within,
::ng-deep input.p-focus,
::ng-deep input.p-highlight {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
::ng-deep .p-dropdown-label {
  padding: 0 !important;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #344054;
  height: 100%;
  width: 100%;
}
::ng-deep .p-dropdown .p-inputtext {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
::ng-deep .p-dropdown-trigger {
  color: #667085;
  justify-content: flex-end;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  margin: 4px 8px;
  border-radius: 6px;
  padding: 6px 12px;
}
::ng-deep .p-dropdown-item.p-highlight {
  color: #D47500;
  background: #FFC680;
}
::ng-deep .p-dropdown-item.p-highlight.p-focus {
  background: #FFF1E0;
}
::ng-deep .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,
::ng-deep .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #4b5563;
  background: #FFF1E0;
}
/*# sourceMappingURL=service-offered-new.component-6SBSGKY6.css.map */
